import script from "./NoReturned.vue?vue&type=script&setup=true&lang=js"
export * from "./NoReturned.vue?vue&type=script&setup=true&lang=js"

import "./NoReturned.vue?vue&type=style&index=0&id=b237a5c0&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b237a5c0"]])

export default __exports__